<div id="home" class="main-banner banner-bg-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8">
                        <div class="banner-text">
                            <h1>
                                تطبيق سريع وموثوق لتتبع الأطفال المفقودين
                                <!-- Super Fast & Reliable Booking App -->
                            </h1>
                            <p>
                                في حال فقدان طفلك قم بتحميل تطبيق Trackid و
                                إنشاء قضية في غضون لحظات وسيتم التواصل معك في
                                حال العثور عليه
                                <!-- حدث اختطاف ؟ ليس لديك الوقت لذهاب  للتبليغ ؟ تحتاج للمساعده على الفور؟ قم بإنشاء قضيتك في غضون لحظة بمساعدة Trackids. -->
                                <!-- Traveling? Don’t have the time to purchase tickets on the spot? Book your tickets within a moment with the help of Euzan. -->
                            </p>
                            <div class="banner-btn">
                                <a routerLink="/app-landing"> تحميل Trackid</a>
                                <button
                                    class="banner-video"
                                    (click)="
                                        ngxSmartModalService
                                            .getModal('popupOne')
                                            .open()
                                    "
                                >
                                    <i class="flaticon-play-button"></i> مشاهدة
                                    الفيديو
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="banner-img text-end">
                            <img
                                src="assets/img/app-landing/img_1.jpeg"
                                alt="iphone"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="banner-shape">
        <img src="assets/img/shape/home-shape.png" alt="shape" />
        <img src="assets/img/shape/home-shape-two.png" alt="shape" />
        <img src="assets/img/shape/home-shape-four.png" alt="shape" />
    </div>
</div>
<div class="video-popup">
    <ngx-smart-modal #popupOne [identifier]="'popupOne'">
        <iframe
            src="https://www.youtube.com/embed/WQ119jAN4Xo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </ngx-smart-modal>
</div>
